import { render, staticRenderFns } from "./CouponsView.vue?vue&type=template&id=3c941060&scoped=true&"
import script from "./CouponsView.vue?vue&type=script&lang=js&"
export * from "./CouponsView.vue?vue&type=script&lang=js&"
import style0 from "./CouponsView.vue?vue&type=style&index=0&id=3c941060&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c941060",
  null
  
)

export default component.exports